import React, { useState, useRef } from 'react';
import { API_BASE_URL, deleteData } from '../../helpers/ApiSettings';
import { Editor } from '@tinymce/tinymce-react';

const EditWorkshopModal = ({ editingWorkshop, setEditingWorkshop, onSubmit, categories }) => {
  const editorRef = useRef(null);
  const [imagePreview, setImagePreview] = useState(null);

  if (!editingWorkshop) return null;

  const handleChange = (e) => {
    const { name, value } = e.target;
    setEditingWorkshop({ ...editingWorkshop, [name]: value });
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setEditingWorkshop({ ...editingWorkshop, image: file });
      setImagePreview(URL.createObjectURL(file));
    }
  };

  const handleAddDate = () => {
    const newDate = { date: '', max_participants: 12 };
    setEditingWorkshop({ ...editingWorkshop, newDates: [...(editingWorkshop.newDates || []), newDate] });
  };

  const handleNewDateChange = (index, key, value) => {
    const updated = [...editingWorkshop.newDates];
    updated[index][key] = value;
    setEditingWorkshop({ ...editingWorkshop, newDates: updated });
  };

  const handleNewDateRemove = (index) => {
    const updated = editingWorkshop.newDates.filter((_, i) => i !== index);
    setEditingWorkshop({ ...editingWorkshop, newDates: updated });
  };

  const handleExistingDateChange = (index, key, value) => {
    const updated = [...editingWorkshop.dates];
    updated[index][key] = value;
    setEditingWorkshop({ ...editingWorkshop, dates: updated });
  };

  const handleExistingDateRemove = async (index, id) => {
    const confirmDelete = window.confirm("Êtes-vous sûr ? Cet date sera immédiatement supprimée.");
    if (!confirmDelete) return;

    try{
      await deleteData(`/workshop-dates/${id}`);
      const updated = editingWorkshop.dates.filter((_, i) => i !== index);
      setEditingWorkshop({ ...editingWorkshop, dates: updated });
    } catch (e) {
      console.error('Error deleting existing date: ', e);
    }
  };

  return (
    <div className="modal" id="editWorkshopModal" tabIndex="-1">
      <div className="modal-dialog modal-lg">
        <div className="modal-content">
          <form onSubmit={onSubmit}>
            <div className="modal-header">
              <h5 className="modal-title">Modifier l'atelier</h5>
              <button type="button" className="btn-close" data-bs-dismiss="modal"></button>
            </div>
            <div className="modal-body">
              <div className="mb-3">
                <label className="form-label">Image</label>
                {imagePreview ? (
                  <img src={imagePreview} alt="preview" className="img-fluid mb-2" style={{ maxHeight: '150px' }} />
                ) : editingWorkshop.image?.url ? (
                  <img src={`${API_BASE_URL}${editingWorkshop.image.url}`} alt="preview" className="img-fluid mb-2" style={{ maxHeight: '150px' }} />
                ) : null}
                <input type="file" className="form-control" accept="image/*" onChange={handleImageChange} />
              </div>

              <div className="row">
                <div className="col-md-6">
                  <label className="form-label">Titre</label>
                  <input type="text" name="title" className="form-control" value={editingWorkshop.title || ''} onChange={handleChange} />
                </div>
                <div className="col-md-6">
                  <label className="form-label">Référence</label>
                  <input type="text" name="reference" className="form-control" value={editingWorkshop.reference || ''} onChange={handleChange} />
                </div>
              </div>

              <div className="mb-3">
                <label className="form-label">Catégorie</label>
                <select className="form-select" name="category" value={editingWorkshop.category?.id || editingWorkshop.category || ''} onChange={handleChange}>
                  <option value="">Sélectionner</option>
                  {categories.map((cat) => (
                    <option key={cat.id} value={cat.id}>{cat.name}</option>
                  ))}
                </select>
              </div>

              <div className="mb-3">
                <label className="form-label">Description courte</label>
                <textarea name="short_description" className="form-control" rows="2" value={editingWorkshop.short_description || ''} onChange={handleChange}></textarea>
              </div>

              <div className="mb-3">
                <label className="form-label">Description</label>
                <Editor
                  onInit={(evt, editor) => editorRef.current = editor}
                  value={editingWorkshop.description || ''}
                  init={{ height: 300, menubar: false, plugins: ['lists', 'autoresize'], toolbar: 'bold italic underline | bullist numlist | removeformat' }}
                  onEditorChange={(content) => setEditingWorkshop({ ...editingWorkshop, description: content })}
                />
              </div>

              <div className="row">
                <div className="col-md-6">
                  <label className="form-label">Durée (heures)</label>
                  <input type="number" name="duration" className="form-control" value={editingWorkshop.duration || ''} onChange={handleChange} />
                </div>
                <div className="col-md-6">
                  <label className="form-label">Prix (€)</label>
                  <input type="number" step="0.00" name="price" className="form-control" value={editingWorkshop.price || ''} onChange={handleChange} />
                </div>
              </div>

              <div className="row mt-3">
                <div className="col-md-6">
                  <label className="form-label">Lieu</label>
                  <input type="text" name="location" className="form-control" value={editingWorkshop.location || ''} onChange={handleChange} />
                </div>
                <div className="col-md-6">
                  {/* <label className="form-label">Participants max</label>
                  <input type="number" name="max_participants" className="form-control" value={editingWorkshop.max_participants || ''} onChange={handleChange} /> */}
                </div>
              </div>

              <hr className="my-4" />
              <h6>Dates existantes</h6>
              {editingWorkshop.dates?.map((d, i) => (
                <div key={d.id || i} className="row align-items-end mb-2">
                  <div className="col-md-6">
                    <label className="form-label">Date</label>
                    <input 
                      type="datetime-local" 
                      className="form-control" 
                      value={d.date ? (() => {
                        const date = new Date(d.date);
                        const year = date.getFullYear();
                        const month = String(date.getMonth() + 1).padStart(2, '0');
                        const day = String(date.getDate()).padStart(2, '0');
                        const hours = String(date.getHours()).padStart(2, '0');
                        const minutes = String(date.getMinutes()).padStart(2, '0');
                        return `${year}-${month}-${day}T${hours}:${minutes}`;
                      })() : ''} 
                      onChange={(e) => {
                        handleExistingDateChange(i, 'date', e.target.value)
                        handleExistingDateChange(i, 'max_participants', 500)
                      }} 
                    />
                  </div>
                  <div className="col-md-4">
                    {/* <label className="form-label">Participants max</label>
                    <input type="number" className="form-control" value={d.max_participants || 12} onChange={(e) => handleExistingDateChange(i, 'max_participants', e.target.value)} /> */}
                  </div>
                  <div className="col-md-2">
                    <button type="button" className="btn btn-danger" onClick={() => handleExistingDateRemove(i, d.documentId)}>Supprimer</button>
                  </div>
                </div>
              ))}

              <hr className="my-4" />
              <h6>Nouvelles dates à ajouter</h6>
              {editingWorkshop.newDates?.map((d, i) => (
                <div key={i} className="row align-items-end mb-2">
                  <div className="col-md-6">
                    <input type="datetime-local" className="form-control" value={d.date} onChange={(e) => handleNewDateChange(i, 'date', e.target.value)} />
                  </div>
                  <div className="col-md-4">
                    <input type="number" className="form-control" value={d.max_participants} onChange={(e) => handleNewDateChange(i, 'max_participants', e.target.value)} />
                  </div>
                  <div className="col-md-2">
                    <button type="button" className="btn btn-danger" onClick={() => handleNewDateRemove(i)}>Supprimer</button>
                  </div>
                </div>
              ))}
              <button type="button" className="btn btn-secondary mt-2" onClick={handleAddDate}>Ajouter une date</button>
            </div>

            <div className="modal-footer">
              <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Annuler</button>
              <button type="submit" className="btn btn-primary">Mettre à jour</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default EditWorkshopModal;
